import { REDIRECT } from '@actions/admin/middlewareActions';

export const redirect = (store) => (next) => (action) => {
    if (action.type === REDIRECT) {
        action.history.push(action.route);
    }

    return next(action);
};
